import DistributorRequests from "app/api/distributor";
import { handleGenericApiError } from "app/api/error";

import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_DISTRIBUTORS = "partner:ACTION_SAVE_DISTRIBUTORS";
export const ACTION_SAVE_DISTRIBUTOR = "partner:ACTION_SAVE_DISTRIBUTOR";

export const fetchDistributors = callback => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await DistributorRequests.fetchDistributors();
    dispatch({ type: ACTION_SAVE_DISTRIBUTORS, payload: data });
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchDistributorById = (id, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await DistributorRequests.fetchDistributorById(id);
    dispatch({ type: ACTION_SAVE_DISTRIBUTOR, payload: data });
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const activeDistributor = id => async dispatch => {
  dispatch(addLoading());
  try {
    await DistributorRequests.activeDistributor(id);
    const data = await DistributorRequests.fetchDistributors();
    dispatch({ type: ACTION_SAVE_DISTRIBUTORS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const activeScoreDistributor = id => async dispatch => {
  dispatch(addLoading());
  try {
    await DistributorRequests.activeScoreDistributor(id);
    const data = await DistributorRequests.fetchDistributors();
    dispatch({ type: ACTION_SAVE_DISTRIBUTORS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const activeCafDistributor = id => async dispatch => {
  dispatch(addLoading());
  try {
    await DistributorRequests.activeCafDistributor(id);
    const data = await DistributorRequests.fetchDistributors();
    dispatch({ type: ACTION_SAVE_DISTRIBUTORS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const activeDiscoDistributor = id => async dispatch => {
  dispatch(addLoading());
  try {
    await DistributorRequests.activeDiscoDistributor(id);
    const data = await DistributorRequests.fetchDistributors();
    dispatch({ type: ACTION_SAVE_DISTRIBUTORS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};
